// @flow
import React from 'react';

import { Subheader, Section } from 'modules/checkout/review/details/Commons';
import t from 'modules/i18n/intl';

const BankTransferOrCheckInstructions = () => (
  <p>{t('review.bank-transfer-or-check.instructions')}</p>
);

const PaymentBankDetails = () => (
  <Section>
    <Subheader>{t('review.bank-transfer-or-check')}</Subheader>
    <BankTransferOrCheckInstructions />
  </Section>
);

export default PaymentBankDetails;
